<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="personalSearchField"
          rounded
          filled
          dense
          hide-details
          background-color="primary"
          color="secondary"
          label="Buscar personal por CUIP"
          append-icon="mdi-magnify"
          @click:append="searchPersonalByCuip"
          @keyup.enter="searchPersonalByCuip"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-virtual-scroll :items="filteredPersonal" item-height="64" height="400">
          <template v-slot:default="{ item }">
            <v-list-item :key="item.idPersonal">
              <v-list-item-avatar>
                <v-img :src="item.foto" v-if="item.foto !== ''"></v-img>
                <v-icon size="48" v-else>mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  <div class="text-subtitle-2 font-weight-bold">{{ getFullName(item) }}</div>
                  <div class="text-subtitle-1" v-if="item.CUIP && item.CUIP.length > 0">{{ item.CUIP }}</div>
                  <div class="text-subtitle-1" v-else>CUIP no asignado</div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-btn
          color="secondary"
          :loading="loading"
          :disabled="loading || searchedPersonal.length === 0"
          @click="agregarElemento"
        >
          Agregar elemento
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { axios } from '@/plugins/axios'
import moment from 'moment'
import DateAdapter from '@/utils/DateAdapter'
import { VUETIFY_DATE_FORMAT } from '@/const'

export default {
  name: 'AsignarPersonalManualmenteConvocatoriaDialogComponent',

  props: {
    convocatoriaData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },

  data() {
    return {
      personalSearchField: '',
      loading: false,
      searchedPersonal: [],
    }
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonal',
    }),

    filteredPersonal() {
      if (this.searchedPersonal.length > 0) {
        return this.searchedPersonal
      }

      if (!this.personalSearchField) {
        return this.personal
      }

      const searchTerm = this.personalSearchField.toLowerCase()
      return this.personal.filter((p) => {
        return (
          (p.nombre && p.nombre.toLowerCase().includes(searchTerm)) ||
          (p.segundoNombre && p.segundoNombre.toLowerCase().includes(searchTerm)) ||
          (p.apaterno && p.apaterno.toLowerCase().includes(searchTerm)) ||
          (p.amaterno && p.amaterno.toLowerCase().includes(searchTerm)) ||
          (p.CUIP && p.CUIP.toLowerCase().includes(searchTerm))
        )
      })
    },
  },

  methods: {
    ...mapActions('convocatorias', ['createPersonalConvocatoria']),

    getFullName(item) {
      const parts = [item.nombre, item.segundoNombre, item.apaterno, item.amaterno].filter(Boolean)
      return parts.join(' ')
    },

    async searchPersonalByCuip() {
      if (!this.personalSearchField || this.personalSearchField.trim() === '') {
        this.searchedPersonal = []
        return
      }

      try {
        this.loading = true
        const response = await axios.post('/EonCloud/EstadoFuerza/search/personal', {
          nombre: '',
          segundoNombre: '',
          apaterno: '',
          amaterno: '',
          curp: '',
          CUIP: this.personalSearchField.trim(),
        })

        if (response.data.data && response.data.data.length > 0) {
          this.searchedPersonal = response.data.data
        } else {
          this.searchedPersonal = []
          this.$store.commit('SET_SNACKBAR_MESSAGE', 'No se encontró personal con ese CUIP')
        }
      } catch (error) {
        console.error('Error al buscar personal por CUIP:', error)
        console.error('Response error:', error.response?.data)

        const errorMessage = error.response?.data?.message || error.response?.data?.error || 'Error al buscar personal'
        this.$store.commit('SET_SNACKBAR_MESSAGE', errorMessage)
        this.searchedPersonal = []
      } finally {
        this.loading = false
      }
    },

    async agregarElemento() {
      if (!this.convocatoriaData?.id) {
        console.error('No se proporcionó ID de convocatoria')
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error: No se proporcionó el ID de la convocatoria')
        return
      }

      if (this.searchedPersonal.length === 0) {
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Debe buscar y seleccionar un elemento')
        return
      }

      try {
        this.loading = true
        const idPersonal = this.searchedPersonal[0].idPersonal
        const fechaActual = moment().format(VUETIFY_DATE_FORMAT)
        const dateAdapter = new DateAdapter(fechaActual, VUETIFY_DATE_FORMAT)
        const fechaRegistro = dateAdapter.toApiSupportedFormat()

        const payload = {
          fk_idConvocatoria: this.convocatoriaData.id,
          fechaRegistro: fechaRegistro,
        }

        console.log('Datos a enviar:', {
          idPersonal,
          payload,
          fechaFormateada: fechaRegistro,
        })

        await this.createPersonalConvocatoria({ idPersonal, payload })

        this.searchedPersonal = []
        this.personalSearchField = ''

        this.$emit('personal-added')
        this.$store.commit('dialog/CLOSE_DIALOG')
      } catch (error) {
        console.error('Error al agregar elemento:', error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
